var WidgetHostResolver = /** @class */ (function () {
    function WidgetHostResolver() {
    }
    WidgetHostResolver.resolve = function (hosts, group, language) {
        var providerHosts = hosts.filter(function (host) { return host.providerId === group.providerId; });
        var providerLanguageHosts = providerHosts.filter(function (host) { return host.language === language; });
        return providerLanguageHosts[0] || providerHosts[0] || hosts[0];
    };
    return WidgetHostResolver;
}());
export { WidgetHostResolver };
